import { makeStyles } from '@material-ui/core';

export const useSessionTimeOut = makeStyles((theme) => {
  return ({
    btn_primary: {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:hover': {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
      }
    },
    titleIcon: {
      color: 'var(--warning-orange)', 
      verticalAlign: 'bottom'
    }
  });
});